import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchQuery: '',
  selectedCategory: '',
  categories: [],
  priceRanges: [],
  services: [],
  hasPromotions: false,
  isOpen: false,
  appliedFilters: {
    category: '',
    search: '',
  },
  isFilterApplied: false,
};

const searchFiltersSlice = createSlice({
  name: 'searchFilters',
  initialState,
  reducers: {
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
    applyFilters: (state, action) => {
      const { searchQuery, category } = action.payload;
      state.appliedFilters = {
        search: searchQuery || '',
        category: category || '',
      };
      state.isFilterApplied = true;
    },
    clearFilters: (state) => {
      state.searchQuery = '';
      state.selectedCategory = '';
      state.categories = [];
      state.priceRanges = [];
      state.services = [];
      state.hasPromotions = false;
      state.isOpen = false;
      state.appliedFilters = {
        search: '',
        category: '',
      };
      state.isFilterApplied = false;
    },
    applyCategoryFilter: (state, action) => {
      state.selectedCategory = action.payload;
      state.appliedFilters.category = action.payload;
      state.isFilterApplied = true;
    },
    applySearchFilter: (state, action) => {
      state.searchQuery = action.payload;
      state.appliedFilters.search = action.payload;
      state.isFilterApplied = true;
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
      state.isFilterApplied = state.categories.length > 0 || state.priceRanges.length > 0 || 
                              state.services.length > 0 || state.hasPromotions || state.isOpen || 
                              state.searchQuery.length > 0;
    },
    setPriceRanges: (state, action) => {
      state.priceRanges = action.payload;
      state.isFilterApplied = state.categories.length > 0 || state.priceRanges.length > 0 || 
                              state.services.length > 0 || state.hasPromotions || state.isOpen || 
                              state.searchQuery.length > 0;
    },
    setServices: (state, action) => {
      state.services = action.payload;
      state.isFilterApplied = state.categories.length > 0 || state.priceRanges.length > 0 || 
                              state.services.length > 0 || state.hasPromotions || state.isOpen || 
                              state.searchQuery.length > 0;
    },
    setHasPromotions: (state, action) => {
      state.hasPromotions = action.payload;
      state.isFilterApplied = state.categories.length > 0 || state.priceRanges.length > 0 || 
                              state.services.length > 0 || state.hasPromotions || state.isOpen || 
                              state.searchQuery.length > 0;
    },
    setIsOpen: (state, action) => {
      state.isOpen = action.payload;
      state.isFilterApplied = state.categories.length > 0 || state.priceRanges.length > 0 || 
                              state.services.length > 0 || state.hasPromotions || state.isOpen || 
                              state.searchQuery.length > 0;
    },
    updateFilters: (state, action) => {
      const { categories, priceRanges, services, hasPromotions, isOpen } = action.payload;
      if (categories !== undefined) state.categories = categories;
      if (priceRanges !== undefined) state.priceRanges = priceRanges;
      if (services !== undefined) state.services = services;
      if (hasPromotions !== undefined) state.hasPromotions = hasPromotions;
      if (isOpen !== undefined) state.isOpen = isOpen;
      state.isFilterApplied = state.categories.length > 0 || state.priceRanges.length > 0 || 
                              state.services.length > 0 || state.hasPromotions || state.isOpen || 
                              state.searchQuery.length > 0;
    },
  },
});

export const {
  setSearchQuery,
  setSelectedCategory,
  applyFilters,
  clearFilters,
  applyCategoryFilter,
  applySearchFilter,
  setCategories,
  setPriceRanges,
  setServices,
  setHasPromotions,
  setIsOpen,
  updateFilters,
} = searchFiltersSlice.actions;

export default searchFiltersSlice.reducer;
